import { createReducer, on } from '@ngrx/store';

import {
  getDigitalProductsSubscriptionsSuccess,
  getOrderPlanOverviewListSuccess,
  linkCropFields,
  loadCustomerProgressSuccess,
  loadOrderedBemProductsSuccess,
  optimizeOrderPlanSuccess,
  saveDigitalProductsSubscriptions,
  setAvailableYears,
  setCropAids,
  setCropFields,
  setCustomerProductInventory,
  setCustomerPreferences,
  setDefaultYear,
  setLoggedInEmployeeData,
  setOrderedId,
  setOrderLines,
  setOrderPlanByCropAids,
  setOrderPlanByPeriods,
  setPackages,
  setPeriodSystem,
  setPreferredDeliveryPeriods,
  setProprietaryCropAids,
  setSalesOrderPeriods,
  setShipTosWithOrders,
} from './actions';
import { AppState } from '../shared/models';

export const initialAppState: AppState = {
  orderedBemProducts: [],
}

export const appReducer = createReducer(
  initialAppState,

  on(setLoggedInEmployeeData, (state, { loggedInEmployee }): AppState => ({
    ...state,
    loggedInEmployee,
  })),

  on(setOrderPlanByPeriods, (state, { orderPlanByPeriods }): AppState => ({
    ...state,
    orderPlanByPeriods,
    orderPlanLoaded: true,
  })),

  on(setOrderPlanByCropAids, (state, { orderPlanByCropAids }): AppState => ({
    ...state,
    orderPlanByCropAids,
  })),

  on(setOrderLines, (state, { gbmOrderLines }): AppState => ({
    ...state,
    gbmOrderLines,
  })),

  on(setPackages, (state, { packages }): AppState => ({
    ...state,
    packages,
  })),

  on(setCropAids, (state, { cropAids }): AppState => ({
    ...state,
    cropAids,
  })),

  on(setProprietaryCropAids, (state, { cropAids }): AppState => ({
    ...state,
    proprietaryCropAids: cropAids,
  })),

  on(setDefaultYear, (state, { defaultYear }): AppState => ({
    ...state,
    defaultYear,
  })),

  on(setAvailableYears, (state, { availableYears }): AppState => ({
    ...state,
    availableYears,
  })),

  on(setSalesOrderPeriods, (state, { salesOrderPeriods }): AppState => ({
    ...state,
    salesOrderPeriods,
  })),

  on(setOrderedId, (state, { orderedId }): AppState => ({
    ...state,
    orderedId,
  })),

  on(setPreferredDeliveryPeriods, (state, { preferredDeliveryPeriods }): AppState => ({
    ...state,
    preferredDeliveryPeriods,
  })),

  on(setCustomerPreferences, (state, { preferredDeliveryPeriods, periodSystem }): AppState => ({
    ...state,
    preferredDeliveryPeriods,
    periodSystem,
  })),

  on(setPeriodSystem, (state, { periodSystem }): AppState => ({
    ...state,
    periodSystem,
  })),

  on(setCropFields, (state, { cropFields }): AppState => ({
    ...state,
    cropFields,
  })),

  on(setCustomerProductInventory, (state, { productInventories }): AppState => ({
    ...state,
    customerProductInventory: productInventories,
  })),

  on(setShipTosWithOrders, (state, { shipToIds }): AppState => ({
    ...state,
    shipTosWithOrders: shipToIds,
  })),

  on(loadCustomerProgressSuccess, (state, { customerProgress }): AppState => ({
    ...state,
    customerProgress,
  })),

  on(optimizeOrderPlanSuccess, (state, { isOrderPlanOptimized }): AppState => ({
    ...state,
    isOrderPlanOptimized,
  })),

  on(getOrderPlanOverviewListSuccess, (state, { orderPlanOverviewV2List }): AppState => ({
    ...state,
    orderPlanV2: orderPlanOverviewV2List,
    orderPlanLoaded: true,
  })),

  on(linkCropFields, (state, { cropFieldLinkType }): AppState => ({
    ...state,
    cropFieldLinkType,
  })),

  on(
    saveDigitalProductsSubscriptions,
    getDigitalProductsSubscriptionsSuccess,
    (state, { requisites }): AppState => ({
      ...state,
      digitalProductSubscriptions: requisites,
    })),

  on(loadOrderedBemProductsSuccess, (state, { payload }): AppState => ({
    ...state,
    orderedBemProducts: payload.products,
  })),
)
